/**
 * Networks Page Logic
 *
 * Admin network/bridge management page
 */

import { initAuthenticatedPage, hasPermission } from '../app/init.js';
import { fillBridgesTable, setNetHost } from '../admin/networks.js';
import { api } from '../api/client.js';
import { apiCall } from '../api/helpers.js';
import { generateComboSelect } from '../ui/forms.js';
import { declareLoading, declareLoaded, notificationDialog } from '../ui/dialogs.js';

/**
 * Initialize the networks page
 */
export async function initNetworksPage(): Promise<void> {
  const user = await initAuthenticatedPage();
  if (!user) return; // Will redirect to login

  // Check admin permission
  if (!hasPermission('admin')) {
    notificationDialog('Access denied: Admin permission required');
    window.location.href = '/';
    return;
  }

  // Load host dropdown (only show if multiple hosts exist)
  const hosts = await apiCall(api.getHostsForDropdown(), 'Failed to Load Hosts');
  if (hosts && Object.keys(hosts).length > 1) {
    const container = document.getElementById('net-host-selector');
    if (container) {
      container.innerHTML = '<label>Host:&nbsp;</label>' + generateComboSelect('net-host-select', '', hosts);
      container.style.display = '';
      $('#net-host-select').on('change', function () {
        setNetHost($(this).val() as string);
      });
    }
  }

  // Load bridges table
  declareLoading();
  try {
    await fillBridgesTable();
    // Show content after table is ready
    const content = document.getElementById('content');
    if (content) content.style.display = 'block';
  } catch (error) {
    const msg = error instanceof Error ? error.message : 'Failed to load networks';
    notificationDialog(msg);
  }
  declareLoaded();
}

// Export to window for onclick handlers
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).initNetworksPage = initNetworksPage;
}
